import { Button, ModalWindow, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackResultClose } from './tracking';
import { closeCalculateResultModal } from '../../actions/calculateResultModal';
import { CalculateResultModalContent } from '../../components/CalculateResult';
import { selectCalculateResult } from '../../selectors/calculate';
import { selectCalculateResultModalOpen } from '../../selectors/calculateResultModal';
import { TThunkDispatch } from '../../types/redux/thunk';
import { CalculateResultContainer } from '../CalculateResultContainer';

export const CalculateResultModalContainer: React.FC = () => {
  const deviceType = useDeviceType();
  const dispatch = useDispatch<TThunkDispatch>();
  const calculateResult = useSelector(selectCalculateResult);
  const isOpen = useSelector(selectCalculateResultModalOpen);

  const handleClose = React.useCallback(() => {
    if (calculateResult) {
      trackResultClose(calculateResult.conclusion.type);
    }

    dispatch(closeCalculateResultModal());
  }, [calculateResult, dispatch]);

  if (deviceType === 'desktop') {
    return null;
  }

  return (
    <ModalWindow
      open={isOpen}
      onClose={handleClose}
      title="Результат"
      content={
        <CalculateResultModalContent>
          <CalculateResultContainer />
        </CalculateResultModalContent>
      }
      footer={
        <Button onClick={handleClose} fullWidth>
          Понятно
        </Button>
      }
      outside
      fixed
    />
  );
};
